/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["textarea[_ngcontent-%COMP%]{outline:0}.input-wrapper[_ngcontent-%COMP%]{border-bottom:1px solid #d3d3d3!important}"];
export { styles as styles };
